import { useEffect, useState } from 'react'
import cn from 'classnames'
import { Badge } from '@mc/design-system'
import Image from 'components/LegacyImage'
import { useQuizEvents } from '../../events'
import { ButtonsSection } from '../ButtonsSection'
import appearanceClasses from '../../../common/appearance.module.scss'

export interface InterstitialStepProps {
  title?: React.ReactNode
  subtitle?: string
  badge?: string
  image?: string
  children?: React.ReactNode
  showSkip?: boolean
  animateOut?: boolean
  className?: string
}

export const InterstitialStep = ({
  title,
  subtitle,
  badge,
  image,
  showSkip = false,
  children,
  animateOut = false,
  className = 'col-12 col-lg-7',
}: InterstitialStepProps) => {
  const { trackInterstitialScreenViewed, trackClickInterstitial } =
    useQuizEvents()

  const [inAnimation, setInAnimation] = useState(false)

  useEffect(() => {
    trackInterstitialScreenViewed()
  }, [trackInterstitialScreenViewed])

  const onNext = () => {
    trackClickInterstitial({ action: 'Next' })
  }

  const hasHeader = badge || image || subtitle || title

  return (
    <div className='mc-py-7'>
      <div
        className={cn('row no-gutters-vertical justify-content-center', {
          [appearanceClasses.disappearing]: animateOut && inAnimation,
        })}
      >
        <div className={`${className} mc-text--center no-gutters-vertical`}>
          {hasHeader && (
            <div className='d-flex flex-column align-items-center flex-gap-2 mc-py-2'>
              {!!badge && (
                <Badge className='mc-text--uppercase mc-text--bold mc-mb-7'>
                  {badge}
                </Badge>
              )}

              <div className='d-flex flex-column flex-gap-2 mc-text--center mc-mb-7'>
                {!!title && (
                  <h1 className='mc-text-h4 mc-text--center'>{title}</h1>
                )}

                {!!image && (
                  <Image
                    alt=''
                    className={cn('mc-corners--md mc-mt-7', {
                      'mc-mb-7': subtitle,
                    })}
                    src={image}
                    width='680'
                    height='390'
                  />
                )}

                {!!subtitle && (
                  <div className='d-flex align-items-center justify-content-center'>
                    <p className='mc-text--center mc-text-color--tint'>
                      {subtitle}
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}

          {children}
          <ButtonsSection
            onNext={onNext}
            disabled={false}
            showSkip={showSkip}
            animateOut={animateOut}
            setInAnimation={setInAnimation}
          />
        </div>
      </div>
    </div>
  )
}
